'use client';
var GTM_SOURCE = "https://www.googletagmanager.com/gtm.js";

export { GTM_SOURCE };
